'use client';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Autoplay, Keyboard } from 'swiper/modules';
import GallerySlide from './GallerySlide'; // Import the new component

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';

const concepts = [
  {
    title: 'Webová stránka restaurace',
    image: '/projects/restaurant_screenshot.png',
  },
  {
    title: 'Moderní webdesign',
    image: '/projects/website_screenshot.png',
  },
  {
    title: 'Profesionální elegance',
    image: 'https://picsum.photos/seed/corporate/1280/720',
  },
  {
    title: 'Futuristický design',
    image: 'https://picsum.photos/seed/future/1280/720',
  },
  {
    title: 'Hra s barvami',
    image: 'https://picsum.photos/seed/colors/1280/720',
  },
];

const ConceptGallery = () => {
  // Duplicate concepts to ensure seamless looping
  const extendedConcepts = [...concepts, ...concepts];

  return (
    <section id="concepts" className="py-20">
      <div className="container mx-auto px-6 md:px-6">
        <h2 className="text-4xl font-bold text-center text-white mb-4">
          Galerie inspirace
        </h2>
        <p className="text-center text-slate-400 mb-8 md:mb-12 max-w-2xl mx-auto">
          Hledáte inspiraci pro svůj web? Prohlédněte si naše designové koncepty.
        </p>
      </div>
      <div className="w-full overflow-hidden px-0 md:px-6">
        <Swiper
          modules={[EffectCoverflow, Autoplay, Keyboard]}
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={true}
          loop={true}
          slidesPerView={'auto'} // Let Swiper determine the number of slides
          spaceBetween={0}
          keyboard={{
            enabled: true,
          }}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          coverflowEffect={{
            rotate: 0,
            stretch: 40,
            depth: 150,
            modifier: 1,
            slideShadows: false,
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 0,
              coverflowEffect: {
                stretch: 0,
                depth: 0,
                rotate: 0,
                modifier: 1
              }
            },
            640: {
              slidesPerView: 1.5,
              spaceBetween: 20,
              coverflowEffect: {
                stretch: 30,
                depth: 120,
              }
            },
            1024: {
              slidesPerView: 'auto',
              spaceBetween: 0,
              coverflowEffect: {
                stretch: 40,
                depth: 150,
              }
            }
          }}
          className="py-12" // Added padding to make space for the scaled-up slide
        >
          {extendedConcepts.map((concept, index) => (
            <SwiperSlide 
              key={index} 
              className="!w-full sm:!w-4/5 md:!w-3/5 lg:!w-1/2"
            >
              <GallerySlide image={concept.image} title={concept.title} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <p className="text-center text-slate-500 text-sm mt-6 block md:hidden">
        Swipněte pro procházení galerie
      </p>
    </section>
  );
};

export default ConceptGallery;
